// 📱 Navigation Configuration for MainApp
// This file contains all tab and navigation configurations

export const bottomTabs = [
  { id: 'dashboard', label: 'Home', icon: '🏠' },
  { id: 'museum', label: 'Museum', icon: '🏟️' },
  { id: 'add-match', label: 'Aggiungi', icon: '➕' },
  { id: 'stats', label: 'Stats', icon: '📊' },
  { id: 'menu', label: 'Menu', icon: '☰' }
];

export const sidebarGroups = [
  {
    id: 'main',
    label: null,
    items: [
      { id: 'dashboard', label: 'Home', icon: '🏠' }
    ]
  },
  {
    id: 'stats',
    label: 'STATISTICHE',
    items: [
      { id: 'stats', label: 'Stats', icon: '📈' },
      { id: 'charts', label: 'Grafici', icon: '📊' },
      { id: 'analytics', label: 'Analisi Pro', icon: '🧠' }
    ]
  },
  {
    id: 'competitions',
    label: 'COMPETIZIONI',
    items: [
      { id: 'tournaments', label: 'Tornei', icon: '🏆' },
      { id: 'calendar', label: 'Calendario', icon: '📅' },
      { id: 'monthly', label: 'Mesi', icon: '📆' },
      { id: 'seasons', label: 'Stagioni', icon: '🍂' }
    ]
  },
  {
    id: 'collection',
    label: 'COLLEZIONE',
    items: [
      { id: 'museum', label: 'Museum', icon: '🏟️' },
      { id: 'opponents', label: 'Avversari', icon: '👥' }
    ]
  },
  {
    id: 'progress',
    label: 'PROGRESSI',
    items: [
      { id: 'challenges', label: 'Obiettivi', icon: '🎯' },
      { id: 'achievements', label: 'Riconoscimenti', icon: '🏆' }
    ]
  },
  {
    id: 'clubs',
    label: 'CLUB',
    items: [
      { id: 'my-clubs', label: 'I Miei Club', icon: '🏢' }
    ]
  },
  {
    id: 'actions',
    label: null,
    items: [
      { id: 'add-match', label: 'Aggiungi Partita', icon: '➕' },
      { id: 'import', label: 'Import Excel', icon: '📥' },
      { id: 'matches', label: 'Partite', icon: '⚽' }
    ]
  },
  {
    id: 'settings',
    label: null,
    items: [
      { id: 'settings', label: 'Impostazioni', icon: '⚙️' }
    ]
  }
];

export const tabs = [
  { id: 'dashboard', label: 'Home', icon: '🏠', shortLabel: 'Home' },
  { id: 'add-match', label: 'Aggiungi', icon: '➕', shortLabel: 'Add' },
  { id: 'import', label: 'Import Excel', icon: '📁', shortLabel: 'Import' },
  { id: 'museum', label: 'Museum', icon: '🏟️', shortLabel: 'Museum' },
  { id: 'stats', label: 'Stats', icon: '📊', shortLabel: 'Stats' },
  { id: 'achievements', label: 'Riconoscimenti', icon: '🏆', shortLabel: 'Premi' },
  { id: 'analytics', label: 'Analisi Pro', icon: '🧠', shortLabel: 'Pro' },
  { id: 'seasons', label: 'Stagioni', icon: '🍂', shortLabel: 'Stagioni' },
  { id: 'challenges', label: 'Obiettivi', icon: '🎯', shortLabel: 'Obiettivi' },
  { id: 'charts', label: 'Grafici', icon: '📈', shortLabel: 'Charts' },
  { id: 'opponents', label: 'Avversari', icon: '👥', shortLabel: 'Vs' },
  { id: 'tournaments', label: 'Tornei', icon: '🏆', shortLabel: 'Tornei' },
  { id: 'calendar', label: 'Calendario', icon: '📅', shortLabel: 'Cal' },
  { id: 'monthly', label: 'Mensili', icon: '📆', shortLabel: 'Mesi' },
  { id: 'matches', label: 'Partite', icon: '⚽', shortLabel: 'Match' },
  { id: 'my-clubs', label: 'I Miei Club', icon: '🏢', shortLabel: 'Club' },
  { id: 'settings', label: 'Impostazioni', icon: '⚙️', shortLabel: 'Config' }
];

// Theme configuration
export const themeOptions = [
  { value: 'light', label: '☀️ Chiaro', icon: '☀️' },
  { value: 'dark', label: '🌙 Scuro', icon: '🌙' },
  { value: 'auto', label: '🌓 Automatico', icon: '🌓' }
];

// Default widget configuration
export const defaultWidgets = [
  { id: 'quick-stats', label: 'Statistiche Rapide', icon: '📊' },
  { id: 'recent-matches', label: 'Ultime Partite', icon: '⚽' },
  { id: 'tournaments', label: 'Tornei Attivi', icon: '🏆' },
  { id: 'streaks', label: 'Serie', icon: '🔥' },
  { id: 'achievements', label: 'Traguardi', icon: '🏅' }
];

// Team types for museum
export const teamTypes = [
  { value: 'Club', label: '🏟️ Club' },
  { value: 'Nazionale', label: '🌍 Nazionale' },
  { value: 'Fantasy', label: '✨ Fantasy' }
];

// Match result types
export const resultTypes = {
  WIN: 'V',
  DRAW: 'P',
  LOSS: 'S'
};

// Category colors
export const categoryColors = {
  training: { bg: 'bg-green-500', text: 'text-green-500', light: 'bg-green-100' },
  club_tournament: { bg: 'bg-blue-500', text: 'text-blue-500', light: 'bg-blue-100' },
  national_tournament: { bg: 'bg-red-500', text: 'text-red-500', light: 'bg-red-100' }
};
